import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export class Home extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true
        }
    }

    componentDidMount() {
        this.httpPost("api/v1/dashboard")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({ data, loading: false });
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({ loading: false });
                }
            });
    }
    formatNumber(num) {
        if (num === undefined || num === null || num === '') return '0';
        return Number(num).toLocaleString('en-US');
        // یا برای فارسی: return Number(num).toLocaleString('fa-IR');
    }
    renderForm() {
        const toNum = (str) => {
            if (!str) return 0;
            return parseInt(str.toString().replace(/,/g, '')) || 0;
        };

        const totalSum =
            toNum(this.state.data.sumSale) +
            toNum(this.state.data.sumDolar) +
            toNum(this.state.data.sumGold) +
            toNum(this.state.data.sumPey) +
            toNum(this.state.data.sumKh) +
            toNum(this.state.data.sumTicket) +
            toNum(this.state.data.sumTran);

        // به همین ترتیب برای مجموع ماهانه
        const totalMonth =
            toNum(this.state.data.sumSaleMonths) +
            toNum(this.state.data.sumDolarMonths) +
            toNum(this.state.data.sumGoldMonths) +
            toNum(this.state.data.sumPeyMonths) +
            toNum(this.state.data.sumKhMonths) +
            toNum(this.state.data.sumTicketMonths) +
            toNum(this.state.data.sumTranMonths);
        const statCards = [
            {
                title: 'جمع کل',
                total: this.formatNumber(totalSum),
                month: totalMonth,
                icon: 'ni-wallet-fill',
                color: '#b45309',
                bgIcon: '🏆'
            },
            { title: 'فروش', total: this.state.data.sumSale, month: this.state.data.sumSaleMonths, icon: 'ni-coins', color: '#3730a3', bgIcon: '💰' },
            { title: 'فروش ارز', total: this.state.data.sumDolar, month: this.state.data.sumDolarMonths, icon: 'ni-sign-dollar', color: '#1e40af', bgIcon: '💵' },
            { title: 'طلا و جواهر', total: this.state.data.sumGold, month: this.state.data.sumGoldMonths, icon: 'ni-star', color: '#b45309', bgIcon: '💎' },
            { title: 'پیمانکاری', total: this.state.data.sumPey, month: this.state.data.sumPeyMonths, icon: 'ni-building', color: '#047857', bgIcon: '🏗️' },
            { title: 'قبوض خدماتی', total: this.state.data.sumKh, month: this.state.data.sumKhMonths, icon: 'ni-file-docs', color: '#0e7490', bgIcon: '📄' },
            { title: 'بلیط هواپیما', total: this.state.data.sumTicket, month: this.state.data.sumTicketMonths, icon: 'ni-ticket', color: '#be123c', bgIcon: '✈️' },
            { title: 'صادرات', total: this.state.data.sumTran, month: this.state.data.sumTranMonths, icon: 'ni-sign-eur', color: '#4f46e5', bgIcon: '🌍' },
        ];

        return (
            <div className="nk-content-body">
                {/* هدر خفن */}
                <div className="dash-header">
                    <div className="dash-greeting">
                        <p>👋 {this.state.data.global.user.fname} {this.state.data.global.user.lname} عزیز، خلاصه وضعیت امروز</p>
                    </div>
                    <div className="dash-date">
                        📅 {new Date().toLocaleDateString('fa-IR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                    </div>
                </div>

                {/* کارت‌های آماری */}
                <div className="row g-4">
                    {statCards.map((card, idx) => (
                        <div className="col-md-3" key={idx}>
                            <div className="card dash-card h-100">
                                <div className="card-inner">
                                    <span className="dash-icon-bg">{card.bgIcon}</span>
                                    <div className="dash-title">
                                   
                                        {card.title}
                                    </div>
                                    <div className="dash-value">{card.total} <small style={{ fontSize: '0.7rem', color: '#64748b' }}>ریال</small></div>
                                    <div className="dash-sub">

                                        <span>ریال</span>
                                  
                                    </div>
                                    <div className="dash-footer">
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* اطلاعات ثبت‌شده */}
                <div className="row g-4 mt-2">
                    <div className="col-12">
                        <div className="card info-card">
                            <div className="info-header">
                                <em className="icon ni ni-chart-bar" style={{ marginLeft: 8 }}></em>
                                اطلاعات ثبت‌شده در سامانه
                            </div>
                            {[
                                { icon: 'ni-building', color: '#3730a3', text: 'مودیان ثبت شده', count: this.state.data.company_count, link: '/companies/' },
                                { icon: 'ni-users', color: '#1e40af', text: 'خریداران ثبت شده', count: this.state.data.customer_count, link: '/persons/' },
                                { icon: 'ni-package-fill', color: '#047857', text: 'کالاها و خدمات', count: this.state.data.stuff_count, link: '/stuffs/' },
                                { icon: 'ni-file-docs', color: '#0e7490', text: 'صورتحساب‌های فروش', count: this.state.data.invoice_count, link: '/invoices/' },
                            ].map((item, idx) => (
                                <NavLink to={item.link} className="info-row" key={idx}>
                          
                                    <span className="info-text">{item.text}</span>
                                    <span className="info-badge">{item.count} عدد</span>
                                    <em className="icon ni ni-chevron-left info-arrow"></em>
                                </NavLink>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}